import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'newPost',
  initialState: {
    show: false,
    post: null,
    hideRecurrent: true,
    isCalendar: false,
    currentClientId: null,
    currentClientSocialNetworks: {},
    currentClientTimeZone: 'Eastern Daylight Time - (GMT-4)',
    currentClientBestTimes: {},
    currentClientMergeFields: {},
    currentCustomerName: '',
    callbackPost: null
  },
  reducers: {
    setNewPostData: (state, { payload }) => {
      state.show = payload.show !== undefined ? payload.show : true;
      state.post = payload.post || null;
      state.hideRecurrent =
        payload.hideRecurrent !== undefined ? payload.hideRecurrent : true;
      state.isCalendar = payload.isCalendar || false;
      state.currentClientId = payload.currentClientId || null;
      state.currentClientSocialNetworks =
        payload.currentClientSocialNetworks || {};
      state.currentClientTimeZone =
        payload.currentClientTimeZone || 'Eastern Daylight Time - (GMT-4)';
      state.currentClientBestTimes = payload.currentClientBestTimes || {};
      state.currentClientMergeFields = payload.currentClientMergeFields || {};
      state.currentCustomerName = payload.currentCustomerName || '';
    },
    clearNewPostData: (state) => {
      state.show = false;
      state.post = null;
      state.hideRecurrent = true;
      state.isCalendar = false;
      state.currentClientId = null;
      state.currentClientSocialNetworks = {};
      state.currentClientTimeZone = 'Eastern Daylight Time - (GMT-4)';
      state.currentClientBestTimes = {};
      state.currentClientMergeFields = {};
      state.currentCustomerName = '';
      state.callbackPost = null;
    },
    setShowNewPost: (state, { payload }) => {
      state.show = payload;
    }
  }
});

export default slice.reducer;

const {
  setNewPostData: setNewPostDataAction,
  clearNewPostData: clearNewPostDataAction,
  setShowNewPost: setShowNewPostAction
} = slice.actions;

export const newPostSelector = (state) => state.newPost;

export const setNewPostData = (payload) => (dispatch) => {
  dispatch(setNewPostDataAction(payload));
};

export const clearNewPostData = () => (dispatch) => {
  dispatch(clearNewPostDataAction());
};

export const setShowNewPost = (show) => (dispatch) => {
  dispatch(setShowNewPostAction(show));
};
